export const SET_DELIVERY_ACTIVE_BUTTON = 'ProductDetails::Body::SetDeliveryActiveButton::Slug';
export const SET_DELIVERY_SORT_DIRECTION = 'ProductDetails::Body::SetDeliverySort::Direction';
export const SET_DELIVERY_POINTS_TO_SHOW = 'ProductDetails::Body::SetDelivery::PointsToShow';
export const HIDE_DELIVERY_POINTS_TO_SHOW = 'ProductDetails::Body::SetDelivery::HidePointsToShow';
export const SET_INITIAL_OFFICES = 'ProductDetails::Body::SetDelivery::SetInitialOffices';
export const SET_TAKEAWAY_FILTERS = 'ProductDetails::Body::SetDelivery::SetTakeawayFilters';
export const SET_PRODUCT_DETAILS_OFFICES = 'ProductDetails::Body::SetDelivery::SetOffices';
export const SET_PRODUCT_DETAILS_OFFICES_RAW = 'ProductDetails::Body::SetDelivery::SetOfficesRaw';
export const GET_DELIVERY_POINTS = 'ProductCatalog::Takeaway::GetDeliveryPoints';
export const GET_DELIVERY_PVZ = 'ProductCatalog::Takeaway::GetDeliveryPVZ';
export const GET_DELIVERY_FRANCHIZE = 'ProductCatalog::Takeaway::GetDeliveryFranchize';
export const GET_DELIVERY_MOVEMENTS = 'ProductCatalog::Takeaway::GetDeliveryMovements';
export const SET_POINTS_LOADING = 'ProductCatalog::Takeaway::SetPointsLoading';
export const SET_BASKET_ID = 'ProductCatalog::Takeaway::SetBasketId';
export const SET_ORDER_INFO = 'ProductCatalog::Takeaway::SetOrderInfo';
export const SET_ORDER_LOADING = 'ProductCatalog::Takeaway::SetOrderInfoLoading';
export const DELIVERY_POINTS_SHOW_COUNT = 5;
export const DELIVERY_POINT_VIEW_MAP = 'map';
export const DELIVERY_POINT_VIEW_LIST = 'list';

export const DELIVERY_POINT_SORT_DATE = 'date';
export const DELIVERY_POINT_SORT_METRO = 'metro';
export const DELIVERY_POINT_SORT_ADDR = 'address';

export const DELIVERY_POINT_GTM_VIEW_MAP = 'Карта';
export const DELIVERY_POINT_GTM_VIEW_LIST_SORT_METRO = 'Метро';
export const DELIVERY_POINT_GTM_VIEW_LIST_SORT_ADDR = 'Адрес';
export const DELIVERY_POINT_GTM_VIEW_LIST_SORT_DATE = 'Дата';
